/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MerchantDTO
 */
export interface MerchantDTO {
  /**
   *
   * @type {number}
   * @memberof MerchantDTO
   */
  id: number | null;
}

/**
 * Check if a given object implements the MerchantDTO interface.
 */
export function instanceOfMerchantDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;

  return isInstance;
}

export function MerchantDTOFromJSON(json: any): MerchantDTO {
  return MerchantDTOFromJSONTyped(json, false);
}

export function MerchantDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"]
  };
}

export function MerchantDTOToJSON(value?: MerchantDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id
  };
}
